/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect, useRef } from 'react';
import { CarouselProps } from '../../types/home';
import { ImagePath } from '../../helper/constants';
import OptimizedImage from '../about/OptimizedImage';
import './video.css';
import Modal from "react-modal";
import HomeModel from './homeModel';
import VideoModal from './homeModel';
type ActiveVideo = {
  url: string;
  id: string;
};
declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: () => void;
  }
}
Modal.setAppElement("#root");
const HomeCarousel: React.FC<CarouselProps> = ({ 
  sliderData, 
  currentIndex, 
  onNext, 
  onPrev, 
  onSlideChange,
  isMobile = false 
}) => {
  const carouselRef = useRef<HTMLDivElement>(null);
const [open, setOpen] = useState(false);

const [play, setPlay] = useState(false);
const openModal = () => {
  setOpen(true);
  setPlay(true);
};
const closeModal = () => {
  setPlay(false);   // 🔥 remove iframe first
  
};

  // Auto-play functionality
  useEffect(() => {
    if (!sliderData?.slider_images) return;

    const interval = setInterval(() => {
      onNext();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [sliderData, onNext]);

  // Keyboard navigation
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (carouselRef.current && document.activeElement === carouselRef.current) {
        if (e.key === 'ArrowRight') onNext();
        if (e.key === 'ArrowLeft') onPrev();
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onNext, onPrev]);

  if (!sliderData?.slider_images?.length) {
    return <div>No slider data available</div>;
  }

  const slides = sliderData.slider_images;
  //  for (let i = 0; i < slides.length; i++) { 
  //   //  if(i === 4){
  //   //  slides[i].video_url = "https://www.youtube.com/watch?v=vZORRVfFknY";
  //   //  slides[i].file_type = 'remote_video';
  //   // }
  //   const video = slides[i].video_url;
   
  //     if(video && slides[i].file_type === 'remote_video'){
  //      slides[i].video_url = video ? video.replace("watch?v=", "embed/").toString() : "";
  //      const videoId = slides[i].video_url.split("/embed/")[1];
  //     }
  // }
  if(isMobile === false){
    for (let i = 0; i < slides.length; i++) {
        const video = slides[i].video_url;
         const buttonUrl = slides[i].button_url;

        if (video && buttonUrl && slides[i].file_type === "remote_video") {
          // 1️⃣ Convert watch URL → embed URL
          const embedUrl = video ? video.replace("watch?v=", "embed/").toString() : "";
          const embedbtnUrl = buttonUrl ? buttonUrl.replace("watch?v=", "embed/").toString() : "";
          // 2️⃣ Extract clean video ID (no extra params)
          const videoId = embedUrl.split("/embed/")[1]?.split("?")[0];
          const btnUrlId = embedbtnUrl.split("/embed/")[1]?.split("?")[0];
          // 3️⃣ Save both (important)
          slides[i].video_url = embedUrl;
          slides[i].video_id =String(videoId);
          slides[i].button_url = embedbtnUrl;
           slides[i].btnUrl_Id = btnUrlId;
         const videos_Id = videoId;
          //console.log(slides[i].video_url,"Destop");
          // eslint-disable-next-line react-hooks/rules-of-hooks
        
        }
    }
  }
  if(isMobile === true){
    for (let i = 0; i < slides.length; i++) {
        const video = slides[i].button_url;

        if (slides[i].file_type !== "remote_video") {
          if (
            slides[i].file_type === "image" &&
            typeof video === "string" &&
            video.startsWith("https://www.youtube.com/watch?v")
          ) {
  // 1️⃣ Convert watch URL → embed URL
          const embedUrl = video ? video.replace("watch?v=", "embed/").toString() : "";

          // 2️⃣ Extract clean video ID (no extra params)
          const videoId = embedUrl.split("/embed/")[1]?.split("?")[0];

          // 3️⃣ Save both (important)
          slides[i].video_url = embedUrl;
          slides[i].video_id = videoId;
           slides[i].button_url = embedUrl;
           slides[i].btnUrl_Id = videoId;
         // console.log(slides[i].video_url,"mobile");
          // eslint-disable-next-line react-hooks/rules-of-hooks
          }
        }

    }
    // console.log(slides,"mobilearray")
  }

const playerRefs = useRef<Record<string, any>>({});
const [muted, setMuted] = useState<Record<string, boolean>>({});
const [videoUrl, setVideoUrl] = useState<string | null>(null);
const [videoId, setVideoId] = useState<string | null>(null);
const [openM, setOpenM] = useState<boolean>(false);
const playerRef = useRef<any>(null);
const [activeVideo, setActiveVideo] = useState<ActiveVideo | null>(null);
useEffect(() => {
  if ((window as any).YT?.Player) return;

  const script = document.createElement("script");
  script.src = "https://www.youtube.com/iframe_api";
  script.async = true;
  document.body.appendChild(script);
}, []);

const openVideoModal = (slide: any) => {
 // if (!slide.video_url || !slide.video_id) return;
// localStorage.removeItem('MobileVideoUrl');
// localStorage.removeItem('MobileVideoUrlId');
  // setActiveVideo({
  //   url: slide.video_url,
  //   id: slide.video_id,
  // });
  if(slide.video_url && slide.video_id){
    setVideoUrl(slide.video_url);
    setVideoId(slide.video_id);
  

    // localStorage.setItem('MobileVideoUrl' ,slide.video_url ? slide.video_url  : "https://www.youtube.com/embed/3TXRxmixleM" );
    // localStorage.setItem('MobileVideoUrlId' ,slide.video_id ? slide.video_id : "3TXRxmixleM");
   }

  setOpenM(true);
};
const videoRefs = useRef<Record<string, HTMLDivElement | null>>({});
const [mutedbtn, setMutedbtn] = useState<Record<string, boolean>>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrls, setVideoUrls] = useState<string | null>(null);
  const [videoIds, setVideoIds] = useState<string | null>(null);

  const openVideoModalNew = (slide: any) => {
    setVideoUrls(slide.button_url || slide.video_url);
    setVideoIds(slide.btnUrl_Id || slide.video_id);
    setIsModalOpen(true);
  };


useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const videoId = entry.target.getAttribute("data-video-id");
        if (!videoId) return;

        const player = playerRefs.current[videoId];
        if (!player) return;

        if (!entry.isIntersecting) {
          // 🔇 mute player
          player.mute();

          // 🔴 SYNC REACT STATE (THIS WAS MISSING)
          setMuted((prev) => ({
            ...prev,
            [videoId]: true,
          }));
        }
      });
    },
    { threshold: 0.4 }
  );

  Object.values(videoRefs.current).forEach((el) => {
    if (el) observer.observe(el);
  });

  return () => observer.disconnect();
}, []);
  return (
    <>
      <div
        id={`carouselhomebanner${isMobile ? "" : ""}`}
        className={`carousel carousel-container slide ${
          isMobile ? "d-md-none d-sm-block" : "d-lg-block d-md-block d-sm-none"
        }`}
        ref={carouselRef}
        tabIndex={0}
        style={{ outline: "none", position: "relative", overflow: "hidden" }}
      >
        {/* id={`carouselhomebanner${isMobile ? 'mobile' : ''}`} */}
        {/* Slides */}
        <div className="carousel-inner">
          {slides.map((slide: any, idx: number) => (
            <div
              key={idx}
              className={`carousel-item ${
                idx === currentIndex ? "active" : ""
              }`}
            >
              {/* Desktop Image */}
              {slide.file_type === "remote_video" ? (
                <>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: `
                            .video-wrapper .carousel-indicators {
                              margin-bottom: 0.5rem !important;
                            }
                            .carousel-control-next, .carousel-control-prev{
                              z-index:9 !important;
                            }
                          `,
                    }}
                  />

                  <div className="videoWrappermobile video-wrapper d-block  w-100">
                    <div  data-video-id={slide.video_id} ref={(el) => {
                          videoRefs.current[slide.video_id] = el;
                        }}>
                    <iframe
                      id={`player-${slide.video_id}`}
                      className="videoFrame"
                      src={`${slide.video_url}?autoplay=1&mute=1&loop=1&playlist=${slide.video_id}&controls=0&rel=0&modestbranding=1&playsinline=1&enablejsapi=1`}
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      onLoad={() => {
                        if (
                          (window as any).YT &&
                          !playerRefs.current[slide.video_id]
                        ) {
                          playerRefs.current[slide.video_id] = new (
                            window as any
                          ).YT.Player(`player-${slide.video_id}`, {
                            events: {
                              onReady: (e: any) => {
                                e.target.mute(); // required for autoplay
                                setMuted((m) => ({
                                  ...m,
                                  [slide.video_id]: true,
                                }));
                              },
                            },
                          });
                        }
                      }}
                    /></div>
                    <div className="video-iframe-background">
                      <div className="carousel-caption video-carousel-caption">
                        <div className="row gy-4 flex-lg-row-reverse flex-md-row-reverse justify-content-between">
                          <div
                            className="col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-center text-center justify-content-center"
                            data-aos="fade-in"
                          >
                            <label className="home-banner-title banner-h1">
                              {/* <label>
                                {slide.slider_title
                                  ? slide.slider_title.replace(/<[^>]*>/g, "")
                                  : ""}
                              </label> */}
                              <span>
                                {slide.slider_title
                                  ? slide.slider_title.replace(/<[^>]*>/g, "")
                                  : ""}
                              </span>
                              <br></br>

                              <label>
                                {slide.slider_desc
                                  ? slide.slider_desc.replace(/<[^>]*>/g, "")
                                  : ""}
                              </label>
                            </label>
                            <div>
                              <a
                                onClick={() => {
                                    const player = playerRefs.current[slide.video_id];
                                    if (!player) return;
                                    if (player) {
                                      player.mute(); // 🔥 force mute background
                                    }

                                    setMuted(prev => ({
                                      ...prev,
                                      [slide.video_id]: true,
                                    }));
                                        setOpen(true);
                                      }}
                                className="btn-get-started"
                              >
                                {slide.button_title ? slide.button_title : " "}
                              </a>
                              {/* <button
                                className="mute-btn ms-2 "
                                onClick={() => {
                                  const player =
                                    playerRefs.current[slide.video_id];
                                  if (!player) return;

                                  if (muted[slide.video_id]) {
                                    player.unMute();
                                    player.setVolume(100);
                                  } else {
                                    player.mute();
                                  }

                                  setMuted((prev) => ({
                                    ...prev,
                                    [slide.video_id]: !prev[slide.video_id],
                                  }));
                                }}
                              >
                                {muted[slide.video_id] ? (
                                  <i className="bi bi-volume-mute-fill"></i>
                                ) : (
                                  <i className="bi bi-volume-up-fill"></i>
                                )}
                              </button> */}
                              <button
                                  className="mute-btn ms-2"
                                  onClick={() => {
                                    const player = playerRefs.current[slide.video_id];
                                    if (!player) return;

                                    setMuted((prev) => {
                                      const isMuted = prev[slide.video_id] ?? true;

                                      if (isMuted) {
                                        player.unMute();
                                        player.setVolume(100);
                                      } else {
                                        player.mute();
                                      }

                                      return {
                                        ...prev,
                                        [slide.video_id]: !isMuted,
                                      };
                                    });
                                  }}
                                >
                                  {muted[slide.video_id] ? (
                                    <i className="bi bi-volume-mute-fill" />
                                  ) : (
                                    <i className="bi bi-volume-up-fill" />
                                  )}
                                </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {isMobile === false && (
                      <Modal
                        isOpen={open}
                        onRequestClose={() => setOpen(false)}
                        className="video-modal "
                        overlayClassName="video-overlay"
                        shouldCloseOnOverlayClick={true}
                      >
                        <div className="modal-overlay">
                          <div className="modal-content">
                            <button
                              className="close-btn"
                              onClick={() => setOpen(false)}
                            >
                              ✖
                            </button>

                            <iframe
                              className="videoFrame-model"
                              // src={`${slide.video_url}?autoplay=1&mute=0&rel=0&modestbranding=1&playsinline=1&controls=1`}
                              src={`${slide.button_url}?autoplay=1&mute=0&loop=1&playlist=${slide.btnUrl_Id}&rel=0`}
                              title="YouTube video"
                              frameBorder="0"
                              allow="autoplay; encrypted-media"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                      </Modal>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <OptimizedImage
                    src={`${ImagePath}${slide.slider_img_url}`}
                    alt={slide.slide_img_name}
                    className="d-lg-block d-md-block d-sm-none w-100"
                    loading={idx === 0 ? "eager" : "lazy"}
                  />

                  <OptimizedImage
                    src={`${ImagePath}${slide.slider_img_url}`}
                    alt={slide.slide_img_name}
                    className="d-md-none d-sm-block w-100"
                    loading={idx === 0 ? "eager" : "lazy"}
                  />
                </>
              )}
              {/* Caption */}
              <div
                className={`carousel-caption ${
                  slide.file_type === "remote_video" ? "d-none" : "d-md-block"
                }`}
              >
                <div className="row gy-4 flex-lg-row-reverse flex-md-row-reverse justify-content-between">
                  <div
                    className="col-lg-6 col-md-6 me-lg-5 me-md-5 col-sm-12 d-flex flex-column text-md-start text-sm-center justify-content-center"
                    data-aos="fade-in"
                  >
                    <label className="home-banner-title banner-h1">
                      {/* <span dangerouslySetInnerHTML={{ __html: slide.slider_title }} /> */}
                      <span>
                        {slide.slider_title
                          ? slide.slider_title.replace(/<[^>]*>/g, "")
                          : ""}
                      </span>
                      <br></br>
                      {/* <label className='mb-0' dangerouslySetInnerHTML={{ __html: slide.slider_desc }} /> */}
                      <label>
                        {slide.slider_desc
                          ? slide.slider_desc.replace(/<[^>]*>/g, "")
                          : ""}
                      </label>
                    </label>
                    <div className="d-flex">
                      {slide.video_url ? (
                        <a
                          onClick={() => openVideoModal(slide)}
                          className="btn-get-started"
                          role="button"
                          title="video"
                        >
                          {slide.button_title}
                        </a>
                      ) : (
                        slide.button_title && (
                          <a
                            href={slide.button_url}
                            title={slide.button_url}
                            className="btn-get-started"
                            rel="noopener noreferrer"
                          >
                            {slide.button_title}
                          </a>
                        )
                      )}
                    </div>
                    {isMobile && (
                      <Modal
                        isOpen={openM}
                        onRequestClose={() => setOpenM(false)}
                        className="video-modal"
                        overlayClassName="video-overlay"
                        closeTimeoutMS={200} // smooth animation
                      >
                        <div className="modal-overlay">
                          <div className="modal-content">
                            <button
                              className="close-btn"
                              onClick={() => setOpenM(false)}
                            >
                              ✖
                            </button>

                            {openM && videoUrl && (
                              <iframe
                                className="videoFrame-model-mobile"
                                src={`${videoUrl}?autoplay=1&mute=0&controls=1&loop=1&playlist=${videoId}&playsinline=1&rel=0`}
                                title="YouTube video"
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                              />
                            )}
                          </div>
                        </div>
                      </Modal>
                    )}
                  </div>
                </div>
              </div>

              {/* {videoUrl && videoId && (
                          <Modal
                            isOpen={open}
                            onRequestClose={() => setOpen(false)}
                            className="video-modal"
                            overlayClassName="video-overlay"
                          >
                            <div className="modal-overlay">
                              <div className="modal-content">
                                <button
                                  className="close-btn"
                                  onClick={() => setOpen(false)}
                                >
                                  ✖
                                </button>

                                <iframe
                                  className="videoFrame-model"
                                  // src={`${slide.video_url}?autoplay=1&mute=0&rel=0&modestbranding=1&playsinline=1&controls=1`}
                                  src={`${videoUrl}?autoplay=1&mute=0&loop=1&playlist=${videoId}&rel=0`}
                                  title="YouTube video"
                                  frameBorder="0"
                                  allow="autoplay; encrypted-media"
                                  allowFullScreen
                                ></iframe>
                              </div>
                            </div>
                          </Modal>
                          )} */}
            </div>
          ))}
        </div>

        {/* Indicators */}
        <div
          className="carousel-indicators"
          style={{ textAlign: "center", marginTop: "10px" }}
        >
          {slides.map((slide: any, idx: number) => (
            <button
              key={idx}
              id={slide.file_type === "remote_video" ? "wrapper-indicator" : ""}
              onClick={() => onSlideChange(idx)}
              className={idx === currentIndex ? "active" : ""}
              data-bs-target="#carouselhomebanner"
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>

        {/* Navigation Buttons */}
        <button
          className="carousel-control-prev"
          type="button"
          onClick={onPrev}
          aria-label="Previous slide"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          onClick={onNext}
          aria-label="Next slide"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      {/* Popup Modal */}
    </>
  );
};

export default HomeCarousel;
